<template>
    <v-container
    class="pfcl1618818594" >
        <h3>{{$t('webboxes.styling.sale.title')}}</h3>
        <v-alert type="info" colored-border border="left" class="mt-3">{{$t('webboxes.styling.sale.text')}}</v-alert>
        <v-text-field class="pfcl1618818600 pr-3" :value="template" @input="$emit('update:template', $event)" :label="$t('webboxes.styling.sale.label')"
                clearable
             />
        <!--
        <v-text-field class="pfcl1618818639" v-model.number="defaultPercentInt" type="number" min="0" max="100" label="Default sale" suffix="%" clearable /> 
        -->
    </v-container>
</template>
<script>
export default {
    name: 'SaleStyling',
    props: { template: String, defaultPercent: Number },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
        defaultPercentInt: {
            get() {
                return this.defaultPercent;
            },
            set(val) {
                this.$emit('update:defaultPercent', val);
            }
        }
    },
    methods: {
    }
}
</script>